export default __webpack_public_path__ + "static/media/girlIcon.78bf9d95.svg";